// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__y0tx5","text_danger":"TablaProducto_text_danger__chWCk","text_success":"TablaProducto_text_success__93OdR"};